import React, { useState, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { LocalStorage } from "../../utils";

const ProtectedRoute = () => {
	const [isAuthenticated, setIsAuthenticated] = useState(null); // null = still checking

	useEffect(() => {
		const accessToken = LocalStorage.get("accessToken");
		try {
			const rawUser = LocalStorage.get("user");
			const user = typeof rawUser === "string" ? JSON.parse(rawUser) : rawUser;
			setIsAuthenticated(!!(accessToken && user?._id));
		} catch {
			setIsAuthenticated(false);
		}
	}, []);

	// Still checking — render nothing to avoid flash
	if (isAuthenticated === null) return null;

	return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
};

export default ProtectedRoute;
